/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S4_P2Inputs */

const en_guide_large_json_files_s4_p2 = /** @type {(inputs: Guide_Large_Json_Files_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For structured analysis, consider converting your JSON array to <a href="/json-to-csv">CSV format</a>, which can be opened in spreadsheet tools or loaded into databases for querying.`)
};

const ko_guide_large_json_files_s4_p2 = /** @type {(inputs: Guide_Large_Json_Files_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구조화된 분석을 위해 JSON 배열을 <a href="/json-to-csv">CSV 포맷</a>으로 변환하는 것을 고려하세요. 스프레드시트 도구에서 열거나 쿼리를 위해 데이터베이스에 로드할 수 있습니다.`)
};

const ja_guide_large_json_files_s4_p2 = /** @type {(inputs: Guide_Large_Json_Files_S4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`構造化された分析には、JSON配列を<a href="/json-to-csv">CSV形式</a>に変換することを検討してください。スプレッドシートツールで開いたり、クエリのためにデータベースに読み込んだりできます。`)
};

/**
* | output |
* | --- |
* | "For structured analysis, consider converting your JSON array to <a href=\"/json-to-csv\">CSV format</a>, which can be opened in spreadsheet tools or loaded int..." |
*
* @param {Guide_Large_Json_Files_S4_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s4_p2 = /** @type {((inputs?: Guide_Large_Json_Files_S4_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S4_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s4_p2(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s4_p2(inputs)
	return ja_guide_large_json_files_s4_p2(inputs)
});